// src/pages/attendance/components/CheckInOutButtons.jsx
import React from "react";
import { Play, Square, Lock, Home, Clock } from "lucide-react";
import { Mo3tiButton } from "./mo3tiComponents";

const CheckInOutButtons = ({
  isLoadingTimeEntries, isCheckingWFH, isOutOfZone, hasApprovedWFHToday,
  locationState, isTimerRunning, hasTodayCheckIn, isProcessing,
  handleStartTimer, handleStopTimer, setShowWFHModal, wfhStatus,
  t, currentTheme, isDarkMode, language, todayCheckInDisplay,
}) => {
  const c = currentTheme.colors;

  if (isLoadingTimeEntries || isCheckingWFH) {
    return (
      <div style={{ display: "flex", gap: "20px", justifyContent: "center", alignItems: "center", flexWrap: "wrap" }}>
        {[0, 1].map((i) => (
          <div key={i} style={{ width: "160px", height: "48px", borderRadius: "12px", background: isDarkMode ? "rgba(255,255,255,0.08)" : "rgba(0,0,0,0.06)", animation: "pulse 1.5s ease-in-out infinite" }} />
        ))}
      </div>
    );
  }

  const locationLoading = locationState.isLoadingArea || locationState.isLoadingUserLocation;
  const checkInDisabled  = isTimerRunning || isProcessing || hasTodayCheckIn || (!hasApprovedWFHToday && (isOutOfZone || locationLoading));
  const checkOutDisabled = !(isTimerRunning || hasTodayCheckIn) || isProcessing || (!hasApprovedWFHToday && (isOutOfZone || locationLoading));
  const wfhDisabled      = hasApprovedWFHToday || wfhStatus === "pending";

  return (
    <>
      <div style={{ display: "flex", justifyContent: "center", gap: "20px", marginBottom: "32px", flexWrap: "wrap" }}>
        <Mo3tiButton variant="primary" icon={(!hasApprovedWFHToday && isOutOfZone) ? Lock : Play} onClick={handleStartTimer} disabled={checkInDisabled} theme={currentTheme}>
          {isProcessing && !isTimerRunning ? t.timeTracker.processingCheckIn
            : (isTimerRunning || hasTodayCheckIn) ? t.timeTracker.alreadyCheckedIn
            : t.timeTracker.checkIn}
        </Mo3tiButton>

        <Mo3tiButton variant="secondary" icon={(!hasApprovedWFHToday && isOutOfZone) ? Lock : Square} onClick={handleStopTimer} disabled={checkOutDisabled} theme={currentTheme}>
          {isProcessing && (isTimerRunning || hasTodayCheckIn) ? t.timeTracker.processingCheckOut
            : !(isTimerRunning || hasTodayCheckIn) ? t.timeTracker.notCheckedIn
            : t.timeTracker.checkOut}
        </Mo3tiButton>

        <Mo3tiButton variant="secondary" icon={Home} onClick={() => setShowWFHModal(true)} disabled={wfhDisabled} theme={currentTheme}>
          {hasApprovedWFHToday ? t.workFromHome.workingFromHome
            : wfhStatus === "pending" ? t.workFromHome.pending
            : t.workFromHome.requestButton}
        </Mo3tiButton>
      </div>

      {/* check-in badge */}
      {hasTodayCheckIn && todayCheckInDisplay && (
        <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "10px", margin: "14px auto 4px", padding: "10px 22px", background: `linear-gradient(135deg,${c.success}18,${c.success}08)`, border: `1.5px solid ${c.success}40`, borderRadius: "50px", width: "fit-content" }}>
          <div style={{ width: "8px", height: "8px", borderRadius: "50%", background: c.success, boxShadow: `0 0 6px ${c.success}`, flexShrink: 0 }} />
          <Clock size={14} color={c.success} strokeWidth={2.5} />
          <span style={{ color: c.success, fontWeight: 700, fontSize: "13px", fontFamily: "'Cairo', sans-serif" }}>
            {language === "ar" ? `وقت الدخول: ${todayCheckInDisplay}` : `Checked in at ${todayCheckInDisplay}`}
          </span>
        </div>
      )}

      {/* WFH approved badge */}
      {hasApprovedWFHToday && (
        <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "8px", padding: "12px 20px", background: `${c.success}15`, border: `1px solid ${c.success}30`, borderRadius: "12px", marginTop: "16px", marginBottom: "16px" }}>
          <Home size={18} color={c.success} />
          <span style={{ color: c.success, fontWeight: "600", fontSize: "14px", fontFamily: "'Cairo', sans-serif" }}>{t.workFromHome.locationBypassed}</span>
        </div>
      )}
    </>
  );
};

export default CheckInOutButtons;